import { TCreateBlankSchemaFieldDTO, TCreateMaintenanceBlankDTO } from '../maintenance.types.ts'

const generateBlankFieldDTO = (index: number): TCreateBlankSchemaFieldDTO => ({
  name: '',
  type: 'STRING',
  instruction: '',
  requirements: '',
  orderingIndex: index,
  defaultValue: '',
  typeEnumId: null,
  typeUnitId: null,
})

const generateCreateBlankDTO = (): TCreateMaintenanceBlankDTO => ({
  name: '',
  fields: [generateBlankFieldDTO(0)],
})

const maintenanceBlanksUtils = { generateCreateBlankDTO, generateBlankFieldDTO }
export default maintenanceBlanksUtils
